import { useEffect, useState } from 'react'
import { Option } from '../../../models'

const useOption = (optionId) => {
  const [option, setOption] = useState(null)

  useEffect(() => {
    if (!optionId) return

    Option
      .find(optionId)
      .then((res) => setOption(res.data))
  }, [optionId])

  return option
}

export default useOption
